<template>
	<div :class="`user-side widget ${showCoachMark ? 'coachmark' : ''}`">
		<div class="user-side-header space-between">
			<section>
				<i class="demo-icon icon-sf-setting" />
				<span>Edit Widget</span>
			</section>
			<section>
				<button type="button" class="sf-button__reset" @click="close">
					<i class="demo-icon icon-sf-close" />
				</button>
			</section>
		</div>
		<div class="user-side-body">
			<div class="sf-input-form underline">
				<span class="label">Search Panel</span>
				<div class="sf-widget-search">
					<el-input class="" placeholder="Panel Name" v-model="keyword" @input="debouncedInput" />
				</div>
			</div>
			<div class="widget-list">
				<div
					class="sf-card bg h-100 sf-widget-container"
					:draggable="!showCoachMark_"
					unselectable="on"
					v-for="([name, { component, ...info }], idx) in filteredWidgetComponents"
					:data-component="name"
					:key="name"
					@click.capture="onClick"
					@dblclick.capture="undefined"
					@drag="throttledDrag"
					@dragend="dragend"
					v-bind="info"
					:ref="`listItem${idx}`"
					:id="`sidebarComponent${idx}`"
				>
					<div class="sf-card__header sf-widget-header">
						<span class="title">{{ info.widgetTitle }}</span>
					</div>
					<component class="sf-widget-body sidebar" :key="name" :is="component" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { GridLayout } from 'vue-grid-layout';
import { serviceComputed, serviceMethods } from '@common/Widget/store/helpers';
import { rootComputed } from '@/store/common/helpers';

let mouseXY = { x: null, y: null };
let DragPos = [{ x: null, y: null, w: 1, h: 1, i: null }];
export default {
	name: 'widget-sidebar',
	created() {
		this.filter();
	},
	mounted() {
		document.addEventListener(
			'dragover',
			function (e) {
				mouseXY.x = e.clientX;
				mouseXY.y = e.clientY;
			},
			false
		);
	},
	data() {
		// console.log('data');
		return { filteredWidgetComponents: [], keyword: '' };
	},
	methods: {
		...serviceMethods,
		onClick(e) {
			e.stopPropagation();
			e.preventDefault();
		},
		getPlaceholder() {
			return this.refGridLayout.$children.find(r => r.$el.classList.contains('vue-grid-placeholder'));
		},
		drag: function (e) {
			let parentRect = document.getElementById('widgetRegion').getBoundingClientRect();
			const mouseInGrid = this.inRegion(mouseXY);
			if (mouseInGrid) {
				let placeHolder = this.getPlaceholder();
				placeHolder.dragging = { top: mouseXY.y - parentRect.top, left: mouseXY.x - parentRect.left };
				let new_pos = placeHolder.calcXY(placeHolder.dragging.top, placeHolder.dragging.left);
				if (!this.draggingItemIndex) {
					this.setWidgetItems(
						this.layout_.concat([
							{
								// dummy
								...new_pos,
								w: 1,
								h: 1,
								i: this.newKey,
								dragging: true,
								minH: e.target.getAttribute('minH') * 1,
								minW: e.target.getAttribute('minW') * 1
							}
						])
					);

					this.refGridLayout.dragEvent('dragstart', this.draggingItemIndex, new_pos.x, new_pos.y, 1, 1);
				} else {
					this.refGridLayout.dragEvent('dragstart', this.draggingItemIndex, new_pos.x, new_pos.y, 1, 1);
				}
				DragPos.i = this.draggingItemIndex;
				DragPos.x = new_pos.x;
				DragPos.y = new_pos.y;
			}
		},
		dragend: function (e) {
			let mouseInGrid = this.inRegion(mouseXY);
			if (mouseInGrid === true) {
				const widgetTitle = e.target.getAttribute('data-component');
				this.insertWidgetItem_({ ...this.draggingItem, widgetTitle });
			}
			this.refGridLayout.dragEvent('dragend', this.draggingItemIndex, DragPos.x, DragPos.y, 1, 1);
		},
		inRegion(mouseXY) {
			let parentRect = document.getElementById('widgetRegion').getBoundingClientRect();
			return mouseXY.x > parentRect.left && mouseXY.x < parentRect.right && mouseXY.y > parentRect.top && mouseXY.y < parentRect.bottom;
		},
		close() {
			this.$store.commit('widgetStore/toggleWidgetSideBar', false);
		},
		filter() {
			this.filteredWidgetComponents = this.widgetComponents.filter(([key, w]) => {
				if (w.widgetTitle) return w.widgetTitle.includes(this.keyword || '');
			});
			// console.log('filtered', this.keyword, this.widgetComponents, this.filteredWidgetComponents);
		},
		displayCoachMark() {
			// const firstWidgetComp = _.get(this.$refs, 'listItem0.0');
			// console.log(firstWidgetComp);
			// firstWidgetComp.classList.add('coachmark highlight');
		}
	},
	computed: {
		...serviceComputed,
		...rootComputed,
		showCoachMark() {
			return this.showCoachMark_ && this.widgetSideBar;
		},
		newKey() {
			return (_.max(this.layout_.map(r => (/^[0-9]*$/.test(r.i) ? Number(r.i) : -1))) || 0) + 1;
		},
		widgetComponents() {
			const comps = _.mapValues(this.dynamicComp, r => ({ ...r, widgetTitle: this.getMessage_(r.widgetTitle) }));
			return _.sortBy(Object.entries(comps), ([key, item]) => item.widgetKey);
		},

		throttledDrag() {
			const r = _.throttle(this.drag, 200, { trailing: false });
			return r;
		},
		debouncedInput() {
			const r = _.debounce(this.filter, 500);
			return r;
		},
		draggingItemIndex() {
			const index = this.layout_.findIndex(r => r.dragging);
			if (index === -1) {
				return null;
			}
			const i = this.layout_[index].i;
			// console.log('draggingItemIndex', i);
			return i;
		},
		draggingItem() {
			return this.layout_.find(r => r.dragging);
		}
	},
	watch: {
		widgetComponents() {
			if (this.widgetComponents) {
				this.filter();
			}
		},
		showCoachMark() {
			if (this.showCoachMark) {
				this.displayCoachMark();
			}
		}
	}
};
</script>

<style></style>
